import { TbRouteSquare } from "react-icons/tb";
import { MdEvent, MdFiberManualRecord, MdHorizontalRule, MdLinearScale, MdLogin, MdLogout, MdMyLocation, MdNotes, MdQrCodeScanner, MdRoute } from "react-icons/md";
//#region src/modules/ServicePeriods/activity-evals/icons.ts
var DATA_TYPE_ICONS = {
	"checkpoint-scan": MdQrCodeScanner,
	"checkpoint-tour": MdRoute,
	event: MdEvent,
	"location-log-entry": MdNotes,
	"patrol-visit": TbRouteSquare,
	"shift-start": MdLogin,
	"user-geo-fence-arrival": MdLogin,
	"user-geo-fence-departure": MdLogout,
	"user-gps-breadcrumb": MdMyLocation
};
var OCCURRENCE_ICONS = {
	cadence: MdFiberManualRecord,
	continuous: MdHorizontalRule,
	count: MdLinearScale
};
//#endregion
export { DATA_TYPE_ICONS, OCCURRENCE_ICONS };

//# sourceMappingURL=icons.js.map